export enum ABTestGroupTypeEnum {
    control,
    variant
}
